module.exports = __webpack_public_path__ + "img/feature_buy_th.ccb0cd54.png";